<form name="payment">

    <button mat-raised-button class="rollit-button mat-full-width-button" color="primary" id="submit-form-eft" (click)="submitFree($event)">continue to rollit wealth</button>


    <img alt="Loading" *ngIf="submitRequest && !signupError" class="loader blue" src="assets/icons/loading-icon.svg" />
</form>